import React from 'react';
import { PhotoshopPicker } from 'react-color';

import Settings from '../settings';
import SaveFdDialog from './save-fd-dialog.jsx';

const { $ } = window;

export default class TextPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.project.currentFontDefinition.export();
    this.state.project = props.project;
    this.state.availableFonts = Settings.get('available-fonts', ['Arial', 'Tahoma', 'Times New Roman'].join("\n"));
    //this.state.enabled = (props.project.activePage && props.project.activePage.selectedLayer && props.project.activePage.selectedLayer.type == 'text');
    //this.state.text = this.state.enabled ? props.project.activePage.selectedLayer.text : '';
    this.state.textLayer = props.textLayer;
    this.state.enabled = props.textLayer != null;
    this.state.text = props.textLayer ? props.textLayer.text : '';
    this.state.angle = props.textLayer ? props.textLayer.angle : '';

    this.state.displayColorPicker = false;
    this.state.displayOutlineColorPicker = false;
    this.state.showSaveFdDialog = false;

    Settings.addOnChangeListener(() => {
      this.setState({
        availableFonts: Settings.get('available-fonts', ['Arial', 'Tahoma', 'Times New Roman'].join("\n"))
      });
    });
  }

  componentDidMount() {
    $('[data-content]').popup();
  }

  componentWillReceiveProps(props) {
    let data = props.project.currentFontDefinition.export();

    if (props.textLayer != this.state.textLayer) {
      data.textLayer = props.textLayer;
      data.enabled = props.textLayer != null;
      data.text = (props.textLayer ? props.textLayer.text : '');
      data.angle = props.textLayer ? props.textLayer.angle : '';
    }

    this.setState(data);
  }

  updateVariable(name, value) {
    if ((name == 'lineHeight' || name == 'outlineSize') && value == '') {
      value = 'auto';
    }

    let data = {};
    data[name] = value;
    this.setState(data);

    let project = this.state.project;
    let textLayer = this.state.textLayer;
    if (name == 'color' || name == 'outlineColor') {
      project.currentFontDefinition[name] = value;

      if (textLayer) {
        textLayer.fontDefinition[name] = value;

        clearTimeout(textLayer.__update_timer);
        textLayer.__update_timer = setTimeout(() => {
          textLayer.update();
        }, 250);
      }

      Settings.set('current-font-definition', JSON.stringify(project.currentFontDefinition.export()));
    } else if (name == 'fontFamily') {
      let fd = null;
      if (value != '' && value[0] == '[' && value[value.length - 1] == ']') {
        let fdName = value.substr(1, value.length - 2);
        fd = project.fontDefinitions.find(x => x.name == fdName);
      }

      if (fd) {
        project.currentFontDefinition = fd.clone();

        if (textLayer) {
          textLayer.fontDefinition = fd.clone();
          textLayer.update();
        }
      } else {
        project.currentFontDefinition[name] = value;
        project.currentFontDefinition.name = '';

        if (textLayer) {
          textLayer.fontDefinition[name] = value;
          textLayer.fontDefinition.name = '';
          textLayer.update();
        }

        this.setState({
          name: ''
        });
      }

      Settings.set('current-font-definition', JSON.stringify(project.currentFontDefinition.export()));
    } else if (name in project.currentFontDefinition) {
      project.currentFontDefinition[name] = value;

      if (textLayer) {
        textLayer.fontDefinition[name] = value;
        textLayer.update();
      }

      Settings.set('current-font-definition', JSON.stringify(project.currentFontDefinition.export()));
    } else if (name == 'text' || name == 'angle') {
      if (textLayer) {
        textLayer[name] = value;

        clearTimeout(textLayer.__update_timer);
        textLayer.__update_timer = setTimeout(() => {
          textLayer.update();
        }, 250);
      }
    }
  }

  update(e) {
    let name = e.currentTarget.name;
    let value;

    if (e.currentTarget.tagName.toLowerCase() == 'button') {
      if (e.currentTarget.dataset.value) {
        value = e.currentTarget.dataset.value;
      } else {
        value = !this.state[name];
      }
    } else {
      value = e.target.value;
    }

    this.updateVariable(name, value);
  }

  updateColor(color, event) {
    this.updateVariable('color', {
      r: color.rgb.r,
      g: color.rgb.g,
      b: color.rgb.b,
      a: 255
    });
  }

  updateOutlineColor(color, event) {
    this.updateVariable('outlineColor', {
      r: color.rgb.r,
      g: color.rgb.g,
      b: color.rgb.b,
      a: 255
    });
  }

  showSaveFdDialog() {
    this.setState({
      showSaveFdDialog: true
    });
  }

  render() {
    let project = this.state.project;

    return (
      <div className="ui basic segment">
        <div className="ui form">
          <div className="field" style={{display: 'flex'}}>
            <select name="fontFamily" className="ui fluid dropdown" value={this.state.name != '' && project.fontDefinitions.find(x => x.name == this.state.name) ? '[' + this.state.name + ']' : this.state.fontFamily} onChange={this.update.bind(this)} style={{width: 'auto', flexGrow: '1'}}>
              {project.fontDefinitions.map(fd => (
                <option key={'[' + fd.name + ']'} value={'[' + fd.name + ']'}>{'[' + fd.name + ']'}</option>
              ))}
              {this.state.availableFonts.split("\n").map(x => (
                <option key={x} value={x}>{x}</option>
              ))}
            </select>
            <button className="ui tiny right floated icon button" onClick={this.showSaveFdDialog.bind(this)} data-content="Сохранить как пресет">
              <i className="pin icon" />
            </button>
          </div>
          <div className="four fields">
            <div className="field">
              <div className="ui left icon input" data-content="Размер шрифта">
                <input type="number" name="fontSize" value={this.state.fontSize} onChange={this.update.bind(this)} />
                <i className="font icon" />
              </div>
            </div>
            <div className="field">
              <div className="ui left icon input" data-content="Высота строки (пусто = автоопределение)">
                <input type="number" name="lineHeight" value={this.state.lineHeight == 'auto' ? '' : this.state.lineHeight} onChange={this.update.bind(this)} />
                <i className="text height icon" />
              </div>
            </div>
            <div className="field">
              <div className="ui left icon input" data-content="Угол поворота">
                <input type="number" name="angle" value={this.state.angle} onChange={this.update.bind(this)} />
                <i className="repeat icon" />
              </div>
            </div>
            <div className="field">
              <div className="ui left icon input" data-content="Размер обводки (пусто = автоопределение)">
                <input type="number" name="outlineSize" value={this.state.outlineSize == 'auto' ? '' : this.state.outlineSize} onChange={this.update.bind(this)} />
                <i className="circle notched icon" />
              </div>
            </div>
          </div>
          <div className="three fields">
            <div className="field">
              <div className="ui tiny icon buttons">
                <button name="fauxBold" className={'ui toggle button' + (this.state.fauxBold ? ' active' : '')} onClick={this.update.bind(this)}>
                  <i className="bold icon" />
                </button>
                <button name="fauxItalic" className={'ui toggle button' + (this.state.fauxItalic ? ' active' : '')} onClick={this.update.bind(this)}>
                  <i className="italic icon" />
                </button>
                <button name="underline" className={'ui toggle button' + (this.state.underline ? ' active' : '')} onClick={this.update.bind(this)}>
                  <i className="underline icon" />
                </button>
              </div>
            </div>
            <div className="field">
              <div className="ui tiny icon buttons">
                <button name="textAlign" data-value="left" className={'ui toggle button' + (this.state.textAlign == 'left' ? ' active' : '')} onClick={this.update.bind(this)}>
                  <i className="align left icon" />
                </button>
                <button name="textAlign" data-value="center" className={'ui toggle button' + (this.state.textAlign == 'center' ? ' active' : '')} onClick={this.update.bind(this)}>
                  <i className="align center icon" />
                </button>
                <button name="textAlign" data-value="right" className={'ui toggle button' + (this.state.textAlign == 'right' ? ' active' : '')} onClick={this.update.bind(this)}>
                  <i className="align right icon" />
                </button>
              </div>
            </div>
            <div className="field">
              <div className="ui tiny icon buttons">
                <button name="color" className="ui button" onClick={() => { this.setState({ displayColorPicker: !this.state.displayColorPicker }) }}>
                  <span style={{display: 'inline-block', width: '12px', height: '12px', background: `rgb(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b})`}} data-content="Цвет текста" />
                </button>
                {this.state.displayColorPicker &&
                  <div style={{position: 'absolute', right: 0, zIndex: 2}}>
                    <div style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0}} onClick={() => { this.setState({ displayColorPicker: false }) }} />
                    <PhotoshopPicker color={this.state.color} onChange={this.updateColor.bind(this)} />
                  </div>
                }
                <button name="outlineColor" className="ui button" onClick={() => { this.setState({ displayOutlineColorPicker: !this.state.displayOutlineColorPicker }) }}>
                  <span style={{display: 'inline-block', width: '12px', height: '12px', background: `rgb(${this.state.outlineColor.r}, ${this.state.outlineColor.g}, ${this.state.outlineColor.b})`}} data-content="Цвет обводки" />
                </button>
                {this.state.displayOutlineColorPicker &&
                  <div style={{position: 'absolute', right: 0, zIndex: 2}}>
                    <div style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0}} onClick={() => { this.setState({ displayOutlineColorPicker: false }) }} />
                    <PhotoshopPicker color={this.state.outlineColor} onChange={this.updateOutlineColor.bind(this)} />
                  </div>
                }
              </div>
            </div>
          </div>
          <div className="field">
            <textarea className="ui input" name="text" id="textLayerContent" value={this.state.text} disabled={!this.state.enabled} placeholder="Текст" onChange={this.update.bind(this)} />
          </div>
        </div>

        <SaveFdDialog toolbar={this} visible={this.state.showSaveFdDialog} />
      </div>
    );
  }
}
